// extracted by mini-css-extract-plugin
export default {"statsCharts":"Charts_statsCharts__zyGBD"};